import React, { Fragment } from 'react'
import { pxToRem, color } from '../../utils'
import styled from 'styled-components'
import Moment from 'react-moment'
import Can from '../../components/Can'
import { Button } from '../../components/Form'

const warningMessage = process.env.REACT_APP_INCOMPATIBILITY_WARNING_MESSAGE || ''

// Button do sistema (sólido, caixa alta, mesmos estados de hover/foco) em vez de um
// botão próprio: é o padrão de ação usado nas demais telas.
const MatrixButton = styled(Button)`
  height: ${pxToRem(40)};
  margin-top: ${pxToRem(10)};
  padding: 0 ${pxToRem(20)};
  font-size: ${pxToRem(13)};
`

const Wrapper = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${pxToRem(35)};
  h1,
  h2,
  strong {
    margin: 0;
    padding: 0;
  }
  h2#warning-message {
    margin: 10px 0 5px 0;
    font-size: ${pxToRem(16)};
    font-style: normal;
    color: #f44336;
  }
  h2 {
    font-size: ${pxToRem(16)};
    font-style: italic;
    margin-top: ${pxToRem(5)};
  }
  h1 {
    font-size: ${pxToRem(21)};
  }
  strong {
    font-size: ${pxToRem(19)};
  }

  @media only screen and (max-width: 700px) {
    h2 {
      font-size: ${pxToRem(13)};
    }
    h1 {
      font-size: ${pxToRem(17)};
    }
    strong {
      font-size: ${pxToRem(15)};
    }
  }

  div:last-child {
    text-align: right;
    span {
      text-transform: capitalize;
      display: block;
      color: ${color.secondary};
      margin-top: ${pxToRem(5)};
      font-size: ${pxToRem(18)};
    }
  }

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    div:last-child {
      text-align: left;
      margin-top: ${pxToRem(20)};
    }
  }
`

class ContentHeader extends React.PureComponent {
  render() {
    const { areaId, lastUpdate, onOpenAreaMatrix } = this.props

    return (
      <Wrapper>
        <div>
          <h1>Análise de Incompatibilidade</h1>
          <h2>Verifique a incompatibilidade dos produtos químicos</h2>
          <h2 id="warning-message">{warningMessage}</h2>
        </div>

        <div>
          {areaId !== 'all' && (
            <Fragment>
              <strong>Atualizado em:</strong>

              {lastUpdate ? (
                <Moment element={'span'} format={'DD/MM/YYYY - HH:mm'} locale={'pt-br'}>
                  {lastUpdate}
                </Moment>
              ) : (
                <span>---</span>
              )}

              {/* permissão própria da matriz, liberada por perfil no cadastro - ver
                  API::AreaPolicy#incompatibility_grid? */}
              {onOpenAreaMatrix && (
                <Can functionality={'incompatibility-analysis-matrix'}>
                  <MatrixButton onClick={onOpenAreaMatrix}>
                    Matriz da área
                  </MatrixButton>
                </Can>
              )}
            </Fragment>
          )}
        </div>
      </Wrapper>
    )
  }
}

export default ContentHeader



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/ContentHeader.js